import { formatOrAnonymize } from "./format-or-anonymize";

const formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'code',
  maximumFractionDigits: 0,
});

export function kEurLong(value?: string | number | null): string {
  const kEurLongOrAnonymized = formatOrAnonymize(value, (value) => formatter.format(+value * 1000));
  return kEurLongOrAnonymized;
}
